import { createFileRoute } from '@tanstack/react-router'
import { StaffKetertiban } from '../../../../components/StaffKetertiban'

export const Route = createFileRoute('/desa/$slug/dashboard/ketertiban')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffKetertiban desaId={desaId} />
  },
})
